/** @jsx jsx */

import { capitalize } from 'lodash';

import { jsx } from '@emotion/core';
import {
  Alert,
  AlertDescription,
  Button,
  ButtonGroup,
  Margin,
} from '@zapier/design-system';

import {
  GET_HELP_CTA,
  GET_HELP_PATH,
} from 'app/developer-v3/teams/team-technical-support-operations/get-help';
import { ZAPIER_APP_BASE_URL } from 'app/common/constants';

const ErrorPage = () => {
  return (
    <Margin margin="40px">
      <Alert status="error" title="Our API seems to be down!">
        <AlertDescription>
          We are sorry for the inconvenience. Please try again later or contact
          support
        </AlertDescription>
      </Alert>
      <Margin margin="40px 0px 0px">
        <ButtonGroup columnSize="minmax(100px, max-content)" justify="center">
          <Button
            aria-label="Click to reload the page"
            color="primary"
            iconBefore="arrowRefresh"
            onClick={() => window.location.reload()}
          >
            Reload
          </Button>
          <Button
            aria-label="Click to follow a link to the help page"
            color="tertiary"
            href={`${ZAPIER_APP_BASE_URL}${GET_HELP_PATH}`}
            iconBefore="commentBlankFill"
            target="_blank"
          >
            {capitalize(GET_HELP_CTA)}
          </Button>
        </ButtonGroup>
      </Margin>
    </Margin>
  );
};

export default ErrorPage;
